import { makePostRequestWithFormData } from '../services/axios';
import { logoutApi } from '../services/services';
import { loadAndAlertMsg } from '../utilities/utilities';
import { clientMsgs } from '../utilities/static-data';
import ClientActions from '../client/client-actions';
import { takeLatest, call } from 'redux-saga/effects';

export default function* logoutSaga() {
	yield takeLatest(ClientActions.API_USER_LOGOUT, logoutUserSession);
}

function* logoutUserSession() {
	try {
		const response = yield call(() => makePostRequestWithFormData(logoutApi, {}));
		if (response !== null && response.status === 200) {
			if (sessionStorage.getItem('access_token') !== null) {
				sessionStorage.clear();
			}
			window.location.href = window.location.origin;
		}
	} catch (error) {
		yield* loadAndAlertMsg(error, clientMsgs.logoutFailed);
	}
}

export const exportForTesting = { logoutUserSession };
